module.exports = __webpack_public_path__ + "img/oguri_kimono_salon_TC.b2f29fd0.jpg";